import {
  SystemPlugin,
} from './SystemPlugin'

import type {
  GenesisExtensionManifest,
} from '../../platform/extensions/types'

export const manifest:
GenesisExtensionManifest = {
  id:
    'system-vps',

  name:
    'Sistema / VPS',

  description:
    'Infraestructura, recursos, servicios, backups y mantenimiento.',

  version:
    '1.0.0',

  apiVersion:
    '1',

  kind:
    'MODULE',

  placement:
    'LEFT',

  priority:
    30,

  enabledByDefault:
    true,

  removable:
    true,

  requiredCapabilities: [
    'system.health.read',
  ],

  component:
    SystemPlugin,
}
